import { jarallax, jarallaxVideo } from 'jarallax';


const shouldDisableVideo = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    window.matchMedia('(forced-colors: active)').matches ||
    window.matchMedia('(prefers-contrast: more)').matches;

jarallaxVideo();

jarallax(document.querySelectorAll('#slider'), {
    speed: 0.2,
    videoSrc: 'https://www.youtube.com/embed/OQcNB1yrUAM?rel=0',
    videoStartTime: 21,
    videoPlayOnlyVisible: false,
    disableVideo: shouldDisableVideo,
    onInit() {
        if (shouldDisableVideo()) {
            document.getElementById('slider')?.classList.add('no-video');
        }
    }
});
